<div class="label-container">
	@for (label of selectedLabels() | slice: 0 : maxLength; track label) {
		<label-badge [label]="label" [showCloseButton]="false" />
	}

	@if (selectedLabels()?.length > maxLength) {
		<div class="toggle-button" (click)="openEntity()">
			+{{ selectedLabels()?.length - maxLength }}
		</div>
	}
</div>
